import { handleResponse } from "utils/utils";
import { authService } from "services";

export const alertNotificationsService = {
	getAll,
	markAsRead,
	markMultipleAsRead,
};

function getAll(createdFrom) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
			"X-Geo-IP": global.GetIPHeader,
		},
	};

	let query = "";
	if (createdFrom) {
		query = `?created_from=${createdFrom}`;
	}

	return fetch(`${global.BASE_API}alert-notifications${query}`, requestOptions).then(
		handleResponse
	);
}

function markAsRead(notificationId, read = true) {
	const requestOptions = {
		method: "PUT",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
			"X-Geo-IP": global.GetIPHeader,
		},
		body: JSON.stringify({ read }),
	};

	return fetch(
		`${global.BASE_API}alert-notifications/${notificationId}`,
		requestOptions
	).then(handleResponse);
}

function markMultipleAsRead(notifications) {
	const requestOptions = {
		method: "PATCH",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
			"X-Geo-IP": global.GetIPHeader,
		},
		body: JSON.stringify(notifications),
	};

	return fetch(`${global.BASE_API}alert-notifications`, requestOptions).then(
		handleResponse
	);
}

